import { makeStyles } from '@material-ui/core/styles';

import { colors } from '../../tokens';

const useStyles = makeStyles(theme => ({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: theme.spacing(3),
    marginBottom: theme.spacing(4),
  },
  title: {
    fontSize: 34,
    lineHeight: 1.1,
    fontWeight: 500,
    color: colors.textPrimary,
    marginBottom: theme.spacing(1),
  },
  updated: {
    fontSize: 16,
    color: colors.textSecondary,
  },
  updatedLine: {
    display: 'flex',
    alignItems: 'center',
  },
  refreshIcon: {
    color: '#F80032',
    fontSize: 18,
  },
  refreshButton: {
    marginLeft: theme.spacing(1),
    padding: 0,
  },
  searchActions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flex: '0 1 380px',
    minWidth: 280,
  },
  search: {
    width: 380,
    maxWidth: '100%',
  },
  searchIcon: {
    fontSize: 24,
    color: '#7a7a7a',
  },
}));

export default useStyles;
